import type { BillingGateModel } from "./types";
import {
  projectAdminBypassGateModel,
  projectBillingGateModel,
} from "./internal/gateProjection";
import { projectBillingAccountState } from "./internal/pageProjection";
import { useBillingWorkflowSnapshot } from "./internal/useBillingWorkflowSnapshot";
import { useIsAdmin } from "@src/api/user-auths/is-admin";

const EMPTY_BY_MODULE_ID: BillingGateModel["byModuleId"] = Object.freeze({});

export const useBillingGateModel = ({
  enabled,
}: Readonly<{ enabled: boolean }>): BillingGateModel => {
  const workflow = useBillingWorkflowSnapshot({
    enabled,
    pollForApprovalReturn: false,
  });
  const isAdmin = useIsAdmin();
  if (isAdmin) {
    return projectAdminBypassGateModel();
  }
  if (
    workflow.status !== "ready" ||
    workflow.rawSnapshot === null ||
    workflow.catalog === null
  ) {
    return {
      byModuleId: EMPTY_BY_MODULE_ID,
      status: workflow.status,
    };
  }

  return projectBillingGateModel({
    accountState: projectBillingAccountState(workflow.rawSnapshot),
    activeSubscriptions:
      workflow.rawSnapshot.subscriptionAccessData.subscriptions.active,
    catalog: workflow.catalog,
    ordersPerMonth: workflow.ordersPerMonth,
    isModular: workflow.rawSnapshot.subscriptionAccessData.org.isModular,
  });
};
